import React, { useRef, useState } from 'react';
import { Box, Typography, Button, Stack, Alert, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';

const BackupRestore = () => {
  const [message, setMessage] = useState(null);
  const fileInput = useRef();
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importPassword, setImportPassword] = useState('');

  // Export all data as JSON
  const handleExport = async () => {
    setMessage(null);
    try {
      const res = await fetch('/api/backup/export');
      const data = await res.json();
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'pos-backup.json';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setMessage({ type: 'error', text: 'Export failed.' });
    }
  };

  // Export products as CSV
  const handleExportCSV = async () => {
    setMessage(null);
    try {
      const res = await fetch('/api/backup/export/products/csv');
      const csv = await res.text();
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'products.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setMessage({ type: 'error', text: 'CSV export failed.' });
    }
  };

  // Import all data from JSON
  const handleImport = async (e) => {
    setMessage(null);
    const file = e.target.files[0];
    if (!file) return;
    setImportFile(file);
    setImportDialogOpen(true);
  };

  const handleImportConfirm = async () => {
    setMessage(null);
    setImportDialogOpen(false);
    if (!importFile) return;
    try {
      const text = await importFile.text();
      const data = JSON.parse(text);
      const res = await fetch('/api/backup/import', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...data, userImportPassword: importPassword }),
      });
      if (res.ok) {
        setMessage({ type: 'success', text: 'Data imported.' });
      } else {
        setMessage({ type: 'error', text: 'Import failed.' });
      }
    } catch {
      setMessage({ type: 'error', text: 'Import failed.' });
    } finally {
      setImportPassword('');
      setImportFile(null);
    }
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stack spacing={2}>
        <Button variant="contained" onClick={handleExport}>Export All Data (JSON)</Button>
        <Button variant="outlined" onClick={handleExportCSV}>Export Products (CSV)</Button>
        <Button variant="contained" color="secondary" onClick={() => fileInput.current.click()}>Import Data (JSON)</Button>
        <input type="file" accept="application/json" ref={fileInput} style={{ display: 'none' }} onChange={handleImport} />
        <Dialog open={importDialogOpen} onClose={() => setImportDialogOpen(false)}>
          <DialogTitle>Set Password for Imported Users</DialogTitle>
          <DialogContent>
            <TextField
              label="Password"
              type="password"
              value={importPassword}
              onChange={e => setImportPassword(e.target.value)}
              fullWidth
              autoFocus
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setImportDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleImportConfirm} variant="contained" disabled={!importPassword}>Import</Button>
          </DialogActions>
        </Dialog>
        {message && <Alert severity={message.type}>{message.text}</Alert>}
      </Stack>
    </Box>
  );
};

export default BackupRestore;
